import {CONFIG_DEV} from './ConfigDev';
import {CONF_AUTH} from './ConfigAuth';
import {CONF_UTIL} from './ConfigUtil';
import {CONFIG_AKM} from './ConfigAkm';

export const CONFIG = CONFIG_DEV;
export const CONFIG_AUTH = CONF_AUTH;
export const CONFIG_UTIL = CONF_UTIL;
export const URL_AKM = CONFIG_AKM;